import React from 'react';
import { Accordion } from 'react-bootstrap';
import { CheckCircleTwoTone } from '@ant-design/icons';
import FactAboutScaffoldingSection1 from '../../../../organisms/factaboutscaffolding/FactAboutScaffoldingSection1';
import { FactsAboutScaffolding } from '../../../../../api';

interface ScaffoldingAccordionItemProps {
    factsAboutScaffoldingData: FactsAboutScaffolding | undefined;
    setFactsAboutScaffoldingData: React.Dispatch<React.SetStateAction<FactsAboutScaffolding | undefined>>;
    factAboutScaffoldingCompletionStatus: boolean;
    workerView: boolean;
}

const ScaffoldingAccordionItem: React.FC<ScaffoldingAccordionItemProps> = ({
    factsAboutScaffoldingData,
    setFactsAboutScaffoldingData,
    factAboutScaffoldingCompletionStatus,
    workerView,
}) => {
    return (
        <>
            {factsAboutScaffoldingData &&
                <Accordion.Item className='accordion-item shadow fw-bold' eventKey="3">
                    <Accordion.Header className={workerView ? "disabled-header" : ""}>
                        Fakta om ställning
                        {factAboutScaffoldingCompletionStatus && <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '25px', marginLeft: '10px' }} />}
                    </Accordion.Header>
                    <Accordion.Body className={workerView ? "disabled-body" : ""}>
                        <fieldset disabled={workerView} className="border-0 m-0 p-0 w-100">
                            <FactAboutScaffoldingSection1
                                factAboutScaffolding={factsAboutScaffoldingData}
                                setFactAboutScaffolding={setFactsAboutScaffoldingData}
                                onUpdate={(newObject) => setFactsAboutScaffoldingData(newObject)}
                            />
                        </fieldset>
                    </Accordion.Body>
                </Accordion.Item>
            }
        </>
    );
};

export default ScaffoldingAccordionItem;
